module.exports = __webpack_public_path__ + "img/planes.dcdbb2e2.png";